import React, { createContext, useContext, useCallback, useMemo } from 'react';
import useAuthStore from '../store/authStore';

const AuthContext = createContext(null);

export const UserRoles = {
  NON_REGISTERED: 'NON_REGISTERED',
  AUTHOR: 'AUTHOR',
  REVIEWER: 'REVIEWER',
  EDITOR: 'EDITOR',
  ADMIN: 'ADMIN',
};

export const AuthProvider = ({ children, initialized = true }) => {
  const { user, isAuthenticated, login, logout } = useAuthStore();

  const hasRole = useCallback((role) => {
    if (!user) return false;
    if (user.roles.includes(UserRoles.ADMIN)) return true;
    return user.roles.includes(role);
  }, [user]);

  const value = useMemo(() => ({
    user,
    login,
    logout,
    hasRole,
    isAuthenticated,
    initialized,
  }), [user, login, logout, hasRole, isAuthenticated, initialized]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
